/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsEmail
 */
export interface MelcoModelsEmail {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsEmail
     */
    html?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsEmail
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsEmail
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsEmail
     */
    email_address?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsEmail
     */
    time_stamp?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsEmail
     */
    is_email_sent?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsEmail
     */
    total?: number;
}

export function MelcoModelsEmailFromJSON(json: any): MelcoModelsEmail {
    return MelcoModelsEmailFromJSONTyped(json, false);
}

export function MelcoModelsEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsEmail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'html': !exists(json, 'html') ? undefined : json['html'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'email_address': !exists(json, 'email_address') ? undefined : json['email_address'],
        'time_stamp': !exists(json, 'time_stamp') ? undefined : (new Date(json['time_stamp'])),
        'is_email_sent': !exists(json, 'is_email_sent') ? undefined : json['is_email_sent'],
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function MelcoModelsEmailToJSON(value?: MelcoModelsEmail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'html': value.html,
        'id': value.id,
        'product_code': value.product_code,
        'email_address': value.email_address,
        'time_stamp': value.time_stamp === undefined ? undefined : (value.time_stamp.toISOString()),
        'is_email_sent': value.is_email_sent,
        'total': value.total,
    };
}


